import { Add, DeleteForever } from '@mui/icons-material';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { Alert, Backdrop, Button, Chip, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, MenuItem, Select, Slide, Snackbar, Stack, TextField, ThemeProvider } from '@mui/material';
import { withStyles } from '@mui/styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import MaterialTable, { MTableToolbar } from 'material-table';
import moment from 'moment';
// import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {iconEndAdornment} from '../../../src/Components/docsAdministrative/JsObjectStyles';
import { RolesBackOffice, RolesCollab } from '../../data/Interfaces';
import Logo from '../../data/Logo';
import usePostRequest from '../../hooks/usePostRequest';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { searchLabelInEnumByValue } from '../../Utils/utils';
import DialogEsnInviteExpert from '../Dialogs/DialogEsnInviteExpert';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
import { defaultMaterialTheme, tableIcons } from './MuiSharedElements';

export const Transition = React.forwardRef(
    function Transition(props, ref) {
        return <Slide
            direction="up"
            ref={ref}
            {...props}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
    });

export const InvitationButton = ({ rowData, getAllExperts, role, isDossierCandidat }) => {
    InvitationButton.propTypes = {
        rowData: PropTypes.any,
        getAllExperts: PropTypes.func,
        role: PropTypes.any,
        isDossierCandidat:PropTypes.any,
    };

    const { postData } = usePostRequest();
    const { i18n } = useTranslation();
    const [openDialog, setOpenDialog] = useState(false);
    const envoyerInvitation = async () => {
        if(isDossierCandidat==false){
            try {
                const response = await postData({
                    url: '/expert/inviteExpertToJoin',
                    payload: {
                        expertId: rowData?.__id,
                        isEsn: role=='esn'? true : false,
                    },
                });
                await getAllExperts();
                console.log('response envoyer inv', response);
            } catch (error) {
                console.log(error);
            }}
        else{
            setOpenDialog(true);
        }
    };

    const LabelButtonEnvoyerInv = () => {
        // * Externe
        if(isDossierCandidat==true){
            return i18n.t('Envoyer une invitation');
        }
        else{
            if (rowData?.isActive == false &&
            (rowData?.inviterBackOfficeId || rowData?.inviterEsnId) &&
            typeof rowData?.isInvitationSent === 'undefined') {
                return i18n.t('Envoyer une invitation');
            }
            else if (rowData?.isInvitationSent == true &&
            rowData?.isActive == false &&
            (rowData?.inviterBackOfficeId || rowData?.inviterEsnId)) {
                return i18n.t('Renvoyer une invitation');
            }
            else if (rowData?.isInvitationSent == true &&
            rowData?.isActive == true &&
            (rowData?.inviterBackOfficeId || rowData?.inviterEsnId)) {
                return i18n.t('Invitation acceptée');
            }
            // * Actif
            else return 'None';
        }
    };

    return (
        <>
            {LabelButtonEnvoyerInv() != 'None' &&
                <Button
                    variant="outlined"
                    onClick={envoyerInvitation}
                    style={{...buttonStyles()}}
                    disabled={rowData?.isActive ? true : false}
                >
                    {LabelButtonEnvoyerInv()}
                </Button>
            }
            {openDialog &&
            <DialogEsnInviteExpert
                open={openDialog}
                setOpen={() => {
                    setOpenDialog(false);
                }}
                getAllExperts={getAllExperts}
                expertId={rowData?.__id}
            />}
        </>

    );
};

export const ChipRoleCollab = ({ rowSelected }) => {
    ChipRoleCollab.propTypes = {
        rowSelected: PropTypes.any,
    };
    const { i18n } = useTranslation();
    return (
        <>
            <Stack
                direction="row"
                spacing={1}
            >
                <>
                    {
                        rowSelected?.role && Object.entries(rowSelected?.role).filter((o) => o[1] === 1).map((o, i) => (
                            <>
                                {/*les scénarios visent à éviter la redondance des statuts (si le collab est admin et littleAdmin en même temps)*/}
                                {((rowSelected?.role['Admin'] == 1 && rowSelected?.role['littleAdmin'] == 1) && o[0] != 'Admin') &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesCollab, o[0]))}
                                        key={i}
                                    />
                                }
                                {((rowSelected?.role['Admin'] == 1 && rowSelected?.role['littleAdmin'] == 0)) &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesCollab, o[0]))}
                                        key={i}
                                    />
                                }
                                {((rowSelected?.role['Admin'] == 0 && rowSelected?.role['littleAdmin'] == 1)) &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesCollab, o[0]))}
                                        key={i}
                                    />
                                }
                                {((rowSelected?.role['Admin'] == 0 && rowSelected?.role['littleAdmin'] == 0)) &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesCollab, o[0]))}
                                        key={i}
                                    />
                                }
                            </>
                        ))
                    }
                </>
            </Stack>
        </>
    );
};
export const ChipRoleBackOffice = ({ rowSelected }) => {
    ChipRoleBackOffice.propTypes = {
        rowSelected: PropTypes.any,
    };
    const { i18n } = useTranslation();
    return (
        <>
            <Stack
                direction="row"
                spacing={1}
            >
                <>
                    {
                        rowSelected?.role && Object.entries(rowSelected?.role).filter((o) => o[1] === 1).map((o, i) => (
                            <>
                                {/*les scénarios visent à éviter la redondance des statuts (si le collab est admin et littleAdmin en même temps)*/}
                                {((rowSelected?.role['Admin'] == 1 && rowSelected?.role['littleAdmin'] == 1) && o[0] != 'Admin') &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesBackOffice, o[0]))}
                                        key={i}
                                    />
                                }
                                {((rowSelected?.role['Admin'] == 1 && rowSelected?.role['littleAdmin'] == 0)) &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesBackOffice, o[0]))}
                                        key={i}
                                    />
                                }
                                {((rowSelected?.role['Admin'] == 0 && rowSelected?.role['littleAdmin'] == 1)) &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesBackOffice, o[0]))}
                                        key={i}
                                    />
                                }
                                {((rowSelected?.role['Admin'] == 0 && rowSelected?.role['littleAdmin'] == 0)) &&
                                    <Chip
                                        label={i18n.t(searchLabelInEnumByValue(RolesBackOffice, o[0]))}
                                        key={i}
                                    />
                                }
                            </>
                        ))
                    }
                </>
            </Stack>
        </>
    );
};

//const helperTextStyles = makeStyles(() => ({

//    error: {
//        '&.MuiFormHelperText-root.Mui-error': {
//            background:'transparent !important'
//        }
//    },
//    input: {
//        background: 'white',
//        borderRadius: '8px',
//    }
//}));

const styles = {
    input: {
        background: 'white',
        borderRadius: '8px',
    },

};

const CustomTextField = withStyles({
    input: styles.input,
})(({ classes, InputProps, name, ...props }) => {
    const { inputSize } = useWindowSize();

    const { errors, showErrors } = useUtilities();
    const error = name in errors ? errors[name] : undefined;

    const inputRef = useRef(null);
    const { i18n } = useTranslation();
    React.useEffect(() => {
        if (!!error && showErrors && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showErrors, error]);

    return (
        <ThemeProvider theme={FieldComponentFont}>
            <TextField
                {...props}
                InputProps={{
                    ...InputProps,
                    classes: {
                        input: classes.input,
                    },
                }}
                name={name || ''}
                size={inputSize}
                error={(!!error && showErrors) || props?.error}
                helperText={(showErrors && (i18n.t(error) ?? '')) || i18n.t(props?.helperText)}
                inputRef={inputRef}
                autoFocus={!!error && showErrors}
                onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
            />
        </ThemeProvider>
    );
});

CustomTextField.propTypes = {
    InputProps: PropTypes.any,
    error: PropTypes.any,
    name: PropTypes.any,
    helperText: PropTypes.any,
};

export const TextFieldComponent = CustomTextField;

//export const NumericFormatCustom = ({width,...props})=>{
//    TextFieldComponent.propTypes = {
//        onChange:PropTypes.func,
//        width:PropTypes.any,
//    };

//    return (
//        <NumericFormat
//            {...props}
//            style={{width:width}}
//            //getInputRef={ref}
//            //onValueChange
//            thousandSeparator
//            valueIsNumericString
//            prefix="%"
//        />
//    );
//};

export const DatePickerComponent =withStyles(() => ({
    root: {
        backgroundColor: 'white', // Set the background color to white
    },
}))(({ width, error, helperText,date,setDate, name, classes, ...props}) => {

    const { errors, showErrors } = useUtilities();
    const errorOfInputValidation = name in errors ? errors[name] : undefined;
    //const helperTestClasses = helperTextStyles();
    const [erroneeDate,setErronneeDate]=useState('');
    const { inputSize } = useWindowSize();
    const { i18n } = useTranslation();

    //* I tried to add validation based on the mui docs, but it didn;t work
    //  https://mui.com/x/react-date-pickers/validation/
    // const [errorx, setError] = React.useState('minDate');
    // const startOfQ12022 = moment('2022-01-01T00:00:00.000');
    // const endOfQ12022 = moment('2022-03-31T23:59:59.999');

    // const errorMessage = React.useMemo(() => {
    //     switch (errorx) {
    //     case 'maxDate':
    //     case 'minDate': {
    //         return 'Please select a date in the first quarter of 2022';
    //     }

    //     case 'invalidDate': {
    //         return 'Your date is not valid';
    //     }
    //     default: {
    //         return '';
    //     }
    //     }
    // }, [errorx]);
    const isValidDate = (date) => {
        // Implement your validation logic here
        return (
            date &&
            moment(date).isValid() &&
            moment(date).date() >= 1 &&
            moment(date).date() <= 31 &&
            moment(date).month() >= 0 &&
            moment(date).month() <= 11
        );
    };

    // moment.locale('en-us');
    moment().utcOffset(moment().utcOffset(), true);
    moment()?.utc().toDate();

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
        >
            <DatePicker
                sx={{

                    '& > :not(style)': { borderRadius: '8px' },
                }}
                value={date}
                onChange={(date) => {
                    if (moment.isMoment(date)) {
                        // Check if date is a moment object
                        if (isValidDate(date)) {
                            // https://github.com/mui/material-ui-pickers/issues/1358
                            // https://stackoverflow.com/questions/28949911/what-does-this-format-mean-t000000-000z - https://stackoverflow.com/questions/53052012/set-timezone-react-datepicker - https://github.com/valor-software/ngx-bootstrap/issues/3609
                            // console.log({
                            //     theOneDateEffective1: moment(date)?.utc().toDate().getFullYear(),
                            //     theOneDateEffective21: moment(date)?.utc().add(moment().utcOffset(), 'minutes').toDate().getFullYear(),
                            //     dateEffective2: moment().utcOffset(date.utcOffset(), true).year(),
                            //     // * removes the offset correctly
                            //     dateEffective4: date?.utc().add(moment().utcOffset(), 'minutes').year(),
                            //     dateEffective44: date?.utc().add(moment().utcOffset(), 'hours').year(),
                            //     // dateEffective3:  moment(date).format('YYYY-MM-DD'),
                            //     // dateEffective: date,
                            //     offset: moment().utcOffset(),
                            //     savedDate: moment(date)?.utc().toDate()
                            // });
                            // setDate(date.utc().add(moment().utcOffset(), 'minutes'));
                            // setDate(moment(date)?.utc().toDate());
                            // setDate(moment(date).utc().set({ hours: 12, minutes: 0, seconds: 0, milliseconds: 0 }).toDate());
                            setDate(moment(date).utc(true).toDate());
                            setErronneeDate('');
                        } else {
                            setDate('');
                            setErronneeDate('Veuillez renseigner une date valide');
                        }
                    } else {
                        // Handle the case when the user clears the date
                        setDate(''); // Update dateExpirationCIN to an empty string
                        setErronneeDate(''); // Clear any error message
                    }
                }}
                // * This {...props} represent what we pass rather than width,
                // * normally it's the value and onChange and label
                {...props}
                name={name}
                renderInput={(params) => (
                    // ! on doit absolument avoir textField et pas txtField component
                    <ThemeProvider theme={FieldComponentFont}>
                        <TextField
                            name={name}
                            autoComplete='off'
                            {...params}
                            //FormHelperTextProps={{ classes: helperTestClasses }}
                            //style={{
                            //    width: width ?? '296px',
                            //    borderRadius: '8px',

                            //}}
                            style={{
                                width: width ?? '296px',
                            }}
                            //FormHelperTextProps={{ classes: helperTestClasses }}
                            //InputProps={{
                            //    classes: {
                            //        input: helperTestClasses.input,
                            //    },
                            //}}

                            sx={{
                                backgroundColor: 'white', // Set the background color to white
                                borderRadius: '8px',
                                '& > :not(style)': {
                                    borderRadius: '8px',
                                },
                            }}
                            size={inputSize}
                            error={(erroneeDate!=''?true:false) || (error || (!!errorOfInputValidation && showErrors))}
                            helperText={i18n.t(erroneeDate) || i18n.t(helperText) || (showErrors && (i18n.t(errorOfInputValidation) ?? ''))}
                            className={classes.root}
                        />
                    </ThemeProvider>
                )}

            />
        </LocalizationProvider>
    );
});
//export const TextFieldComponent = ({ InputProps, ...props }) => {
//    TextFieldComponent.propTypes = {
//        InputProps: PropTypes.any,
//    };
//    return (
//        <ThemeProvider theme={FieldComponentFont2}>
//            <TextField
//                {...props}
//                InputProps={{
//                    ...InputProps,
//                }}
//            />
//        </ThemeProvider>
//    );
//};
//export const BtnComponent =({ InputProps, valueBtn, ...props})=>{

//    BtnComponent.propTypes = {
//        InputProps: PropTypes.any,
//        valueBtn:PropTypes.any,
//    };

//    return (
//        <Button
//            variant="contained"
//            type="submit"
//            style={{
//                background:'#5CC889',
//                borderRadius:'8px',
//                fontFamily: 'Lato',
//                fontStyle: 'normal',
//                fontWeight: '600',
//                fontSize: '17px',
//                lineHeight: '32px',
//                letterSpacing: '-0.15px',

//            }}
//            InputProps={{
//                ...InputProps,
//            }}
//            {...props}
//            //onClick={onSubmit}

//        >
//            {valueBtn}
//        </Button>
//    );

//};

export const SelectComponent = ({ label, val, setVal, listVal, name, ...props }) => {
    SelectComponent.propTypes = {
        listVal: PropTypes.array,
        name: PropTypes.any,
        label: PropTypes.any,
        val: PropTypes.any,
        setVal: PropTypes.func,
    };
    const { errors, showErrors } = useUtilities();
    const error = name in errors ? errors[name] : undefined;
    const { i18n } = useTranslation();
    const { inputSize } = useWindowSize();

    //TODO: add constraint about value/label ..(and others) of listVal to not be null .. otherwise it crashes
    //console.log('listVal',listVal);
    if(listVal!=undefined)
        listVal = listVal.filter((elt)=> elt?.value ||  elt?.country || elt?.label ||elt?.region  || elt?._id || elt?.nom || elt);

    //console.log(' after listVal',listVal);
    return (
        <ThemeProvider theme={FieldComponentFont}>
            <FormControl
                fullWidth
                error={!!error && showErrors}
            >
                <InputLabel
                    shrink={true}
                    id="demo-simple-select-label"
                >{i18n.t(label)}</InputLabel>
                <Select
                    label={i18n.t(label)}
                    {...props}
                    //textFieldProps={{
                    //    label: 'Label',
                    //    InputLabelProps: {
                    //        shrink: true,
                    //    },
                    //}}
                    name={name}
                    notched={true}
                    size={inputSize}
                    sx={{
                        '& > :not(style)': { borderRadius: '8px' },
                    }}
                    value={val}
                    style={{ width: '100%', background: 'white' ,borderRadius: '8px'}}
                    onChange={setVal}
                >
                    {Array.isArray(listVal) && listVal?.map((element, i) => (
                        <MenuItem
                            value={element?.value ||
                                element?.country ||
                                element?.region ||
                                element?._id ||
                                element}
                            key={i}
                            style={{
                                display: element.hidden ? 'none' : 'block',
                                visibility: element.hidden ? 'hidden' : 'visible',
                            }}
                        > {i18n.t(element?.label) ||
                            i18n.t(element?.country) ||
                            i18n.t(element?.region) ||
                            i18n.t(element?.nom) ||
                            i18n.t(element)}</MenuItem>
                    ))}
                </Select>
                <FormHelperText>{showErrors && (i18n.t(error) ?? '')}</FormHelperText>

            </FormControl>
        </ThemeProvider>
    );
};

export const MaterialTableComponent = ({ sort, group, search, options, selectedRow, ...props }) => {
    MaterialTableComponent.propTypes = {
        //width: PropTypes.any,
        options: PropTypes.any,
        sort: PropTypes.any,
        group: PropTypes.any,
        search: PropTypes.any,
        selectedRow: PropTypes.any,
        setSelectedRow: PropTypes.func,

        // bgColor: PropTypes.any,
    };

    // const [selectedRow, setSelectedRow] = React.useState(null);
    // const getRowBackgroundColor = (rowData, index) => {
    //     if (selectedRow === rowData.tableData.id) {
    //         return '#EEE';
    //     }
    //     else if ((index % 2)) {
    //         return '#FFF';
    //     }
    //     else return 'rgba(231, 234, 249, 1)';
    // };
    // * these two solutions causes performance issues
    // const [selectedRow, setSelectedRow] = React.useState(null);
    // const {selectedRow, setSelectedRow} = useCraRdv();
    return (
        <div className='Frame4AllAOs'>
            <ThemeProvider theme={defaultMaterialTheme}>
                <MaterialTable
                    {...props}
                    icons={tableIcons}
                    // onRowClick={((evt, selectedRow) => {
                    //     if(typeof setSelectedRow === 'function') setSelectedRow(selectedRow.tableData.id);}
                    // )}
                    components={{
                        Toolbar: props => (
                            <div style={{ marginLeft:'-40px' }}>
                                <MTableToolbar {...props} />
                            </div>
                        )
                    }}
                    options={{
                        ...options, ...{
                            showTitle: false,
                            search: search,
                            stickyHeader: true,
                            maxBodyHeight: '500px', // Set a fixed height here, in order to have a working stickyHeader
                            exportButton: true,
                            sorting: sort,
                            showColumnsTitle: true,
                            grouping: group,
                            paging: true,

                            pageSize: 5,       // make initial page size
                            emptyRowsWhenPaging: false,   // To avoid of having empty rows
                            pageSizeOptions: [5, 50, 100, 150, 200,250,300],
                            columnsButton: true,
                            toolbarButtonAlignment: 'right',
                            toolbar: true,
                            headerStyle: {
                                //borderRight:'1px solid white',
                                //borderCollapse: 'separate', /* This line */
                                //borderRight: '1px solid #eee',
                                background: '#214DCE',
                                fontFamily: 'Lato',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '12px',
                                lineHeight: '16px',
                                //width:'120px',
                                whiteSpace: 'nowrap',
                                textAlign: 'center',
                                letterSpacing: '0.004em',
                                color: '#FFFFFF',
                            },
                            rowStyle: (rowData, index) => {
                                // if(!bgColor){
                                //     console.log(selectedRow === rowData.tableData.id
                                //         ? '#d5f5e2'
                                //         : index % 2
                                //             ? '#FFF'
                                //             : 'rgba(231, 234, 249, 1)');
                                //     setBgColor(selectedRow === rowData.tableData.id
                                //         ? '#d5f5e2'
                                //         : index % 2
                                //             ? '#FFF'
                                //             : 'rgba(231, 234, 249, 1)');
                                // }
                                return { // null;
                                    backgroundColor: selectedRow === rowData.tableData?.id
                                        ? '#d5f5e2'
                                        : index % 2
                                            ? '#FFF'
                                            : 'rgba(231, 234, 249, 1)',
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    //borderRight:'1px solid white',
                                    fontWeight: '400',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    letterSpacing: '0.004em',
                                    color: '#475063',
                                };
                            }
                            // rowStyle: () => ({
                            //     fontFamily: 'Lato',
                            //     fontStyle: 'normal',
                            //     fontWeight: '400',
                            //     fontSize: '12px',
                            //     lineHeight: '16px',
                            //     whiteSpace: 'nowrap',
                            //     textAlign: 'center',
                            //     letterSpacing: '0.004em',
                            //     color: '#475063',
                            // }),
                        }
                    }}

                />
            </ThemeProvider>
        </div>
    );
};

export const IconTextField =withStyles({
    input: styles.input,
    icon: styles.icon,
}) (({ classes,iconStart, iconEnd, InputProps, ...props }) => {

    IconTextField.propTypes = {
        iconStart: PropTypes.any,
        iconEnd: PropTypes.any,
        InputProps: PropTypes.any,
    };

    const { inputSize } = useWindowSize();
    return (
        <ThemeProvider theme={FieldComponentFont}>
            <TextField
                {...props}
                size={inputSize}
                InputProps={{
                    ...InputProps,
                    classes: {
                        input: classes.input,
                    },

                    startAdornment: iconStart ? (
                        <div className='iconStyleStartAdornment'>
                            <InputAdornment
                                className={classes.icon}
                                position="start"
                            >{iconStart}</InputAdornment>
                        </div>
                    ) : null,
                    endAdornment: iconEnd ? (
                        <div
                            className='iconStyleStartAdornment'
                            style={{...iconEndAdornment(inputSize)}}
                        >
                            <InputAdornment
                                className={classes.icon}
                                position="end"
                            >{iconEnd}</InputAdornment>
                        </div>
                    ) : null
                }}

            />
        </ThemeProvider>
    );
});

export const BackDropCustom = ({ backdropOpen, setBackdropOpen }) => {
    BackDropCustom.propTypes = {
        backdropOpen: PropTypes.any,
        setBackdropOpen: PropTypes.func,
    };
    // console.log('BackDropCustom',backdropOpen);
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
            open={backdropOpen}
            onClick={() => setBackdropOpen(false)}
        >
            {/* <CircularProgress color="inherit" /> */}
            <Logo
                width='138px'
                height='34px'
                isRotate={true}
            />
        </Backdrop>
    );
};
export const SNACK_BAR_CLICKAWAY = 'clickaway';
export const SNACK_BAR_AUTO_HIDDEN_DURATION = 5000;
export const SnackBarCustom = ({ openSnackBar, setOpenSnackBar, snackBarMessage, isSnackBarError }) => {
    SnackBarCustom.propTypes = {
        openSnackBar: PropTypes.any,
        snackBarMessage: PropTypes.any,
        isSnackBarError: PropTypes.bool,
        setOpenSnackBar: PropTypes.func,
    };
    // console.log('SnackBarCustom',openSnackBar);
    const handleCloseSnackBar = (event, reason) => {
        if (reason === SNACK_BAR_CLICKAWAY) {
            return;
        }
        setOpenSnackBar(false);
    };
    return (
        <>
            {snackBarMessage && openSnackBar &&
                <Snackbar
                    // right auto left 50%
                    style={{ right: 'auto', left: '50%' }}
                    open={openSnackBar}
                    autoHideDuration={SNACK_BAR_AUTO_HIDDEN_DURATION}
                    onClose={handleCloseSnackBar}
                >
                    <Alert
                        onClose={handleCloseSnackBar}
                        severity={isSnackBarError ? 'error' :'info'}
                        sx={{ width: '100%' }}
                    >
                        {snackBarMessage}
                    </Alert>
                </Snackbar>}
        </>
    );
};

export const AddButtonItem = ({ array, setArray, label,initialObject }) => {
    AddButtonItem.propTypes = {
        array: PropTypes.any,
        initialObject: PropTypes.any,
        setArray: PropTypes.func,
        label: PropTypes.any,
    };
    // handle click event of the Add button
    const handleAddClickItem = () => {
        setArray([...array, initialObject]);
    };
    return (
        <Button
            className='frame50CvTheque'
            variant="text"
            onClick={handleAddClickItem}
            style={{...buttonStyles(),...{color:'#B0B0B0'}}}
            startIcon={<Add style={{color:'#B0B0B0'}} />}
        >
            {label}
        </Button>
    );
};
export const DeleteButtonItem = ({ array, setArray }) => {
    DeleteButtonItem.propTypes = {
        array: PropTypes.any,
        // index: PropTypes.any,
        setArray: PropTypes.func,
    };
    // handle click event of the Remove button
    const handleRemoveClickItem = (index) => {
        const list = [...array];
        list.splice(index, 1);
        setArray(list);
    };
    return (
        <IconButton onClick={handleRemoveClickItem}>
            <DeleteForever />
        </IconButton>
    );
};

export function NomEmail({ nom, prenom, email }) {
    NomEmail.propTypes = {
        nom: PropTypes.any,
        prenom: PropTypes.any,
        email: PropTypes.any,
    };

    return (
        <div className='frame5Collaborators'>
            <div className='frame6Collaborators'>
                <PermIdentityIcon />
            </div>
            <div className='frame7Collaborators'>
                <p className='frame8Collaborators'>{nom + ' ' + prenom}</p>
                <p className='frame9Collaborators'>{email}</p>
            </div>
        </div>
    );
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

{/*<div style={tableStyle}>
                    <Box
                        sx={{
                            //height: 300,
                            //width: 1128,
                            ////backgroundColor: '#FFFFFF',
                            //'& .super-app-theme--header': {
                            //    backgroundColor: '#214DCE',
                            //    borderRadius: '1px 1px 0px 0px',
                            //    fontFamily: 'Lato',
                            //    fontStyle: 'normal',
                            //    fontWeight: '400',
                            //    fontSize: '12px',
                            //    color: '#FFFFFF',
                            //    lineHeight: '16px'
                            //},
                            //['& .${gridClasses.row}.neg']: {
                            //    backgroundColor: '#E7EAF9',
                            //},
                            //['& .${gridClasses.row}.pos']: {
                            //    backgroundColor: 'white',
                            //},

                        }}
                    >
                        <DataGrid
                            rows={factureRows}
                            columns={factureColumns}
                            //{...tableData}
                            //loading={missions.rows.length === 0}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                            //checkboxSelection
                            disableSelectionOnClick
                            showCellRightBorder='true'
                            //getRowClassName='super-app-theme--'
                            experimentalFeatures={{ newEditingApi: true }}
                            // getRowId={(row) => row.id}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'neg' : 'pos'
                            }
                            //onRowClick={handleClickOpen()}
                            onRowClick={(r) => {
                                // ! it is asynchrone, so we may have some troubles in the future [possible bug]
                                setRowSelected(r.row);
                                console.log(rowselected);
                                console.log(open);
                                handleClickOpen();
                            }}
                            components={{ Toolbar: GridToolbar }}
                        />
                        <Facture
                            scroll='paper'
                            handleClose={handleClose}
                            facture={rowselected}
                            open={open}
                            />

                    </Box>
                </div>*/}
